import getUserGroupRoles from './getUserGroupRoles';

var hasRoleOnGroup = function hasRoleOnGroup(role, groupId) {
  var claims = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (role === 'superadmin') return claims.superadmin;
  var userRoles = getUserGroupRoles(groupId, claims);
  return userRoles.some(function (currentRole) {
    return currentRole === role;
  });
};

export default hasRoleOnGroup;